<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All investors" name="first"></el-tab-pane>
			<el-tab-pane label="New investor" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search investor by name, phone or ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>Gender</label>
						<md-select placeholder="Gender (All)" v-model="search.gender">
							<md-option value="">All</md-option>
							<md-option value="f">Female</md-option>
							<md-option value="m">Male</md-option>
							<md-option value="o">Other</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>

			<md-table v-if="investorList.length > 0">
				<md-table-row>
					<md-table-head>N.o</md-table-head>
					<md-table-head>Investor ID</md-table-head>
					<md-table-head>Name</md-table-head>
					<md-table-head>Phone</md-table-head>
					<md-table-head>Investment</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(investor, index) in investorList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<b>IID: {{ investor.hash_id }}</b><br>
						{{ config.datelify(investor.created_date) }}
					</md-table-cell>
					<md-table-cell><b>{{ investor.name }} ({{ config.getGender(investor.gender) }})</b><br>{{investor.name_khmer}}</md-table-cell>
					<md-table-cell>{{ investor.phone }}</md-table-cell>
					<md-table-cell>
						<b v-if="investor.total_loan != null">
							{{config.moneylify(investor.principal)}} /<br>
							{{config.moneylify(investor.principal+investor.interest)}} /<br>
							{{config.moneylify(investor.total_loan_amount)}}
							({{investor.total_loan}})</b>
						<b v-else>$0.00 (0)</b>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/investors/detail/' + investor.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View this investor</md-tooltip>
							</md-button>
						</router-link>

						<router-link :to="'/investors/edit/'+ investor.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">Edit investor information</md-tooltip>
							</md-button>
						</router-link>
						<a :href="investor.doc_url" target="_blank">
							<md-button class="md-just-icon md-simple md-warning">
								<md-icon>file_copy</md-icon>
								<md-tooltip md-direction="top">Open Document</md-tooltip>
							</md-button>
						</a>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(investor.id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this investor</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="investorList.length == 0 && loadMore == true">No client data.</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Investor Information</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Investor Name *</label>
								<md-input type="text" v-model="investor.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Investor Khmer Name *</label>
								<md-input type="text" v-model="investor.name_khmer"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Gender *</label>
								<md-select placeholder="Gender *" v-model="investor.gender">
									<md-option value="f">Female</md-option>
									<md-option value="m">Male</md-option>
									<md-option value="o">Other</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Date of Birth *</label>
								<md-input type="text" v-model="investor.dob"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Client Phone *</label>
								<md-input type="text" v-model="investor.phone"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ID Card Number *</label>
								<md-input type="text" v-model="investor.id_card"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Occupation *</label>
								<md-input type="text" v-model="investor.occupation"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Address</label>
								<md-input type="text" v-model="investor.address">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Document Link (https://drive.google.com/...)</label>
								<md-input type="text" v-model="investor.doc">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Bank Account</label>
								<md-input type="text" v-model="investor.bank">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Client Note</label>
								<md-input type="text" v-model="investor.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Investor Name</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.name).length > 0">{{investor.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investor Khmer Name</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.name_khmer).length > 0">{{investor.name_khmer}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Gender</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.gender).length > 0 && investor.gender == 'm'">Male</span>
									<span v-else-if="String(investor.gender).length > 0 && investor.gender == 'f'">Female</span>
									<span v-else-if="String(investor.gender).length > 0 && investor.gender == 'o'">Other</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Date of Birth</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.dob).length > 0">{{investor.dob}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Occupation</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.occupation).length > 0">{{investor.occupation}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investor Phone</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.phone).length > 0">{{investor.phone}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ID Card</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.id_card).length > 0">{{investor.id_card}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Address</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.address).length > 0">{{investor.address}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Bank Account</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.bank).length > 0">{{investor.bank}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investor Note</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investor.note).length > 0">{{investor.note}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postInvestor()">Create</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this client ?"
			md-content="This client will be deleted and can't be restored" md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>



</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					gender: ""
				},
				investor: {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					bank: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: "",
					doc: "",
					image_url: ""
				},
				loadMore: true,
				investorList: []

			}
		},
		methods: {
			postInvestor() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/investor/post", {
					investor: this.investor
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Client was created successfully.",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.search.gender = "";
						this.searchHandler();
					}
					// this.loadMoreCompanyButton = true
					// this.memberList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/investor/search", {
					text: this.search.text,
					gender: this.search.gender,
					offset: more ? this.investorList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.investorList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.investor.name).length > 0 && String(this.name_khmer).length > 0
					&& String(this.investor.phone).length > 0 && String(this.investor.gender).length > 0
					&& String(this.investor.dob) && String(this.investor.id_card) && String(this.investor.occupation)
					&& String(this.investor.doc).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.search.gender = "";
				this.investor = {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: ""
				}
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/investor/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "This investor was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/Investors/View.vue